import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isStringInArrayCaseInsensitive } from '../../../../utils';
import { Text } from '../../../../../components/Atoms/Text/Text';
import { TextSizeType } from '../../../../../shared/styling/BaseText/BaseText.enum';
import { FooterColumn, StyledLink } from './FooterLinksColumn.styled';
const columnLink = (item) => (_jsx("li", { children: _jsx(StyledLink, Object.assign({ "data-testid": "footer-link", href: item.url }, { children: item.name }), void 0) }, item.url));
export const FooterLinksColumn = ({ column, accountRoles }) => (_jsxs(FooterColumn, Object.assign({ "data-testid": `footer-column-${column.title.toLowerCase()}` }, { children: [_jsx(Text, Object.assign({ as: "li", textSize: TextSizeType.TEXT16, weight: "bold" }, { children: column.title }), void 0), column.links.reduce((result, item) => {
            if (item.displayFor) {
                if (isStringInArrayCaseInsensitive(accountRoles, item.displayFor)) {
                    result.push(columnLink(item));
                }
            }
            else {
                result.push(columnLink(item));
            }
            return result;
        }, [])] }), void 0));
//# sourceMappingURL=FooterLinksColumn.js.map